import { ALL_PRODUCTS as PRODUCTS } from "@/data/catalog"

const NO_DISCOUNT = new Set(["Backup & Anti-Virus", "AI & Cloud Solutions", "Software Supply", "Support Services"])
export const BULK_TIERS = [
  { min: 10, rate: 0.05 },
  { min: 25, rate: 0.1 },
]

export const isDiscountable = (productId) => {
  const p = PRODUCTS.find((x) => x.id === productId)
  return !!p && !NO_DISCOUNT.has(p.category)
}

export const discountRate = (productId, qty) => {
  if (!isDiscountable(productId)) return 0
  return qty >= 25 ? 0.1 : qty >= 10 ? 0.05 : 0
}

export const lineTotal = (productId, price, qty) => {
  const rate = discountRate(productId, qty)
  return Math.round(price * qty * (1 - rate) * 100) / 100
}
